<div id="snackbar-clicktrap" (click)="cancel()"></div>
<span class="mat-simple-snackbar"
  ><span>{{ text }}</span>
</span>
